import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Instagram, Mail } from 'lucide-react';

// URL da logo original
const LOGO_URL = "https://customer-assets.emergentagent.com/job_pet-photo-storage/artifacts/343ueuet_logo.png";

const Footer = () => {
  return (
    <footer className="bg-[#6B5344] text-[#FCEBC5]">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="logo-container p-1 w-14 h-14 overflow-hidden">
                <img 
                  src={LOGO_URL} 
                  alt="Miaucaomigo Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-2xl font-display font-bold">Miaucaomigo</span>
            </div>
            <p className="text-[#F5E6C8] mb-4 max-w-md">
              Conectando pets perdidos aos seus lares e ajudando animais a encontrarem uma nova família. 
              Juntos, fazemos a diferença na vida dos nossos amigos de quatro patas.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://www.instagram.com/miaucaomigo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#5D4A3A] rounded-full flex items-center justify-center hover:bg-[#7A5B3E] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="mailto:miaucaomigo@gmail.com" className="w-10 h-10 bg-[#5D4A3A] rounded-full flex items-center justify-center hover:bg-[#7A5B3E] transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Navegação</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-[#F5E6C8] hover:text-white transition-colors">Início</Link></li>
              <li><Link to="/galeria" className="text-[#F5E6C8] hover:text-white transition-colors">Galeria</Link></li>
              <li><Link to="/mapa" className="text-[#F5E6C8] hover:text-white transition-colors">Mapa</Link></li>
              <li><Link to="/ongs" className="text-[#F5E6C8] hover:text-white transition-colors">Parceiros</Link></li>
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Para Você</h4>
            <ul className="space-y-2">
              <li><Link to="/cadastrar-pet" className="text-[#F5E6C8] hover:text-white transition-colors">Cadastrar Pet</Link></li>
              <li><Link to="/meus-pets" className="text-[#F5E6C8] hover:text-white transition-colors">Meus Pets</Link></li>
              <li><Link to="/login" className="text-[#F5E6C8] hover:text-white transition-colors">Fazer Login</Link></li>
              <li><Link to="/termos" className="text-[#F5E6C8] hover:text-white transition-colors">Termos e Privacidade</Link></li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-[#7A5B3E] text-center">
          <p className="text-[#F5E6C8] flex items-center justify-center gap-2">
            Feito com <Heart className="w-4 h-4 text-red-400 fill-current" /> para os pets do Brasil
          </p>
          <p className="text-[#C4956A] text-sm mt-2">
            © {new Date().getFullYear()} Miaucaomigo. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
